module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasParent),
      expression: "!hasParent"
    }],
    staticClass: "sc-price-info",
    class: {
      fadeInRight: _vm.show
    }
  }, [_c('div', {
    staticClass: "sc-price"
  }, [_vm._v("\n     $" + _vm._s(parseInt(_vm.price))), _c('span', {
    staticClass: "small"
  }, [_vm._v("." + _vm._s(_vm.price.split(".")[1]))]), _vm._v(" "), (_vm.vat > 0) ? _c('span', {
    staticClass: "sc-price-info-vat"
  }, [_vm._v("+$" + _vm._s(_vm.vat) + " VAT")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f61867c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PriceComponent.vue
// module id = 117
// module chunks = 0